/*# sourceMappingURL=authorisation-details.component-E2UOTUA6.css.map */
